import React from 'react';
import { Link } from '@tanstack/react-router';
import type { Project } from '@interlucent/organization-protocol';
import styles from './ProjectCard.module.css';

interface ProjectCardProps {
  project: Project;
  applicationCount: number;
  onClick?: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

export function ProjectCard({
  project,
  applicationCount,
  onDelete,
  disabled = false
}: ProjectCardProps) {
  return (
    <div className={styles.card}>
      <Link
        to="/projects/$projectId/applications"
        params={{ projectId: project.id }}
        className={styles.cardLink}
        aria-label={`Open project ${project.name}`}
      >
        {/* Thumbnail placeholder */}
        <div className={styles.thumbnail}>
          <div className={styles.thumbnailIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
          </div>
          {/* App count badge */}
          <div className={styles.countBadge}>
            {applicationCount}
          </div>
        </div>

        {/* Info */}
        <div className={styles.info}>
          <h3 className={styles.name}>{project.name}</h3>
          <div className={styles.meta}>
            <span className={styles.appCount}>{applicationCount} apps</span>
          </div>
        </div>
      </Link>

      {/* Hover actions */}
      <div className={styles.actions}>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete();
          }}
          disabled={disabled}
          className={styles.actionButton}
          title="Delete project"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    </div>
  );
}
